'use client'
import { useEffect } from 'react'
import { reportClientError } from '@utils/clientErrors'

export default function GlobalError({
  error,
  reset
}: {
  error: Error
  reset: () => void
}) {
  useEffect(() => {
    console.log('capturing report dialog error', error)
    reportClientError(error, { tags: { source: 'app-error-boundary' } })
  }, [error])

  return (
    <div>
      <h2>Something went wrong!</h2>
      <button onClick={() => reset()}>Try again</button>
    </div>
  )
}
